var map = {
	"./de-DE/btn_vote-s.png": "2dd2",
	"./en-GB/btn_vote-s.png": "c0ec",
	"./en-US/btn_vote-s.png": "ba70",
	"./es-ES/btn_vote-s.png": "5984",
	"./es-MX/btn_vote-s.png": "fd69",
	"./fr-CA/btn_vote-s.png": "3fcd",
	"./fr-FR/btn_vote-s.png": "61b1",
	"./it-IT/btn_vote-s.png": "a9d7",
	"./ja-JP/btn_vote-s.png": "2294",
	"./pt-BR/btn_vote-s.png": "24e1",
	"./zh-TW/btn_vote-s.png": "eaba"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7b33";